/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendActualCapexDto } from '../../models/backend-actual-capex-dto';

export interface MonitoringActualsCapexsList$Params {
  is_leasing?: boolean;

  /**
   * ID сценария для фильтрации списка
   */
  scenario_id?: number;

  /**
   * Поиск по текстовым полям сущности
   */
  search?: string;
}

export function monitoringActualsCapexsList(
  http: HttpClient,
  rootUrl: string,
  params?: MonitoringActualsCapexsList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<Array<BackendActualCapexDto>>> {
  const rb = new RequestBuilder(rootUrl, monitoringActualsCapexsList.PATH, 'get');
  if (params) {
    rb.query('is_leasing', params.is_leasing, {});
    rb.query('scenario_id', params.scenario_id, {});
    rb.query('search', params.search, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<Array<BackendActualCapexDto>>;
    }),
  );
}

monitoringActualsCapexsList.PATH = '/api/monitoring/actuals/capexs/';
